import { Kind } from '../components/prescriptionPad/rightPanel/workspace/PrescribeAutoSuggestV2';
import { LABEL_TYPE, OPTION_SOURCE } from '../components/prescriptionPad/trackSource';
import { GET_DOCTOR_PACKAGES } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

interface Response {
    success: boolean;
    vendor_packages: DoctorPackages;
    error?: string;
}

export type DoctorPackages = DoctorPackage[];

export interface DoctorPackage {
    id: string;
    name: string;
    book: boolean;
    content_ids: string[];
    vendor_names: string[];
    vendor_ids: string[];
    type: string;
    content: string[];
    is_doctor_package: boolean;
    kind: Kind;
    track?: {
        label?: LABEL_TYPE;
        index?: number;
        source?: OPTION_SOURCE | string;
        columnIndex?: number;
    };
}

export default (docid: string): Promise<Response> => {
    return fetchWithRefresh(GET_DOCTOR_PACKAGES(docid)).then((res) => res.json());
};
